import { Link, NavLink } from 'react-router-dom';
import { RiPhoneLine } from 'react-icons/ri';
import { FaPhone } from 'react-icons/fa6';
import { FaMessage } from 'react-icons/fa6';
import { useState } from 'react';
import ContactModal from '../UI/Modal/ContactModal/ContactModal';

// style
import style from './footer.module.css';
//data
import logo from '../../assets/logo/logo.png';
import { menu } from '../../data/menuData';
import { contactData, sotcialData } from '../../data/ContactData';

const Footer = () => {
  const [modalIsOpen, setModal] = useState(false);

  const handelModal = () => {
    setModal(!modalIsOpen);
    !modalIsOpen
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = 'visible');
  };

  return (
    <footer>
      <div className="container">
        <div className={style.content}>
          {/* logo */}
          <div className={style.logo}>
            <Link to="/">
              <img src={logo} alt="sparta" />
            </Link>
          </div>
          {/* nav */}
          <div className={style.nav}>
            {menu
              .map(({ title, subMenu, id }) => {
                const hasSubMenu = subMenu?.length > 0;
                return (
                  <div className={style.links} key={id}>
                    <h3>{title}</h3>
                    <ul>
                      {hasSubMenu &&
                        subMenu.map((i) => (
                          <li className={style.link} key={i.id}>
                            <NavLink to={i.url}>{i.title}</NavLink>
                          </li>
                        ))}
                    </ul>
                  </div>
                );
              })
              .slice(1)}
            {/* contact */}
            <div className={style.links}>
              <h3>Контакты</h3>
              <ul>
                {contactData.map((item) => (
                  <li key={item.id} className={style.contact_links}>
                    <span className={style.icon}>{item.icon}</span>
                    <span className={style.text}>{item.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* /// */}

          {/* /// */}
          <div className={style.botton}>
            <span className={style.copy}>
              © 2025 - Sparta Казань, Татарстан
            </span>
            <Link className={style.lega} to="/privacy">
              Защита данных и условия использование
            </Link>
            <ul className={style.sotcial}>
              {sotcialData.map((item) => (
                <li key={item.id}>
                  <a href={item.url} target="_blanck">
                    {item.icon}
                  </a>
                </li>
              ))}
              <li>
                <a href="tel:+78432587426">
                  <RiPhoneLine />
                </a>
              </li>
            </ul>
            {/* /// */}
            <div className={style.call_block}>
              <div className={style.send}>
                <a href="https://wa.me/+79625522333" target="_blanck">
                  <FaMessage />
                  Написать
                </a>
              </div>
              <div className={style.call}>
                <a href="tel:+78432587427">
                  <FaPhone />
                  Позвонить
                </a>
              </div>
            </div>
            {/* /// */}
          </div>
        </div>
      </div>
      <ContactModal modalIsOpen={modalIsOpen} handelModal={handelModal} />
    </footer>
  );
};
export default Footer;
